<template>
    <div>
        <div class="empty-data-wrap" v-show="emptyFlag">
            <img class="card" src="@/assets/image/emptyBlue.png" />
        </div>
        <div v-show="!emptyFlag" :id="id" class="char-wrap" :style="{'height': height}"></div>
    </div>
</template>

<script>
export default {
    name: "lineBarChar",
    data() {
        return {
            charEle: null,
            emptyFlag: false,
        };
    },
    props: {
        id: {
            type: String,
            required: true
        },
        charData: {
            type: Array,
        },
        height: {
            type: String,
            default: "400px"
        },
    },
    mounted() {
        this.drawChart();
    },
    watch: {
        // 监听charData，当放生变化时，触发这个回调函数绘制图表
        charData: {
            handler() {
                this.drawChart();
            },
            deep: true
        }
    },
    methods: {
        drawChart() {
            // Step 1: 创建 Chart 对象
            if (this.charEle == null) {
                this.charEle = this.$echarts.init(document.getElementById(this.id));
            } else {
                this.charEle.clear();
            }

            // Step 2: 数据判断是否为空
            this.checkEmptyDataFlag(this.charData);

            let renderData = [];
            let xAxisData = [];
            let legendData = []; // ['合同金额(万元)', '合同已开票(万元)', '合同数量(份)']
            this.charData.forEach(item => {
                if (xAxisData.indexOf(item.name) === -1) {
                    xAxisData.push(item.name);
                }
                let render = renderData.find(x => x.tip === item.tip);
                if (render) {
                    render.data.push(item.value);
                } else {
                    if (['合同金额', '合同已开票'].indexOf(item.tip) > -1) {
                        legendData.push(`${item.tip}(万元)`);
                    } else if (['合同数量'].indexOf(item.tip) > -1) {
                        legendData.push(`${item.tip}(份)`);
                    }
                    renderData.push({
                        tip: item.tip,
                        data: [item.value]
                    });
                }
            })

            // Step 3: 处理数据
            let seriesData = [];
            renderData.forEach(item => {
                let oneSeries = {};
                if (['合同金额', '合同已开票'].indexOf(item.tip) > -1) {
                    oneSeries = {
                        name: `${item.tip}(万元)`,
                        type: 'bar',
                        yAxisIndex: 0,
                        barWidth: this.charData.length > 30 ? 15 : 20,
                        barGap: '40%',
                        itemStyle: {
                            color: 'auto',
                            borderRadius: 8
                        },
                        data: item.data,
                    };
                    seriesData.push(oneSeries);
                } else if (['合同数量'].indexOf(item.tip) > -1) {
                    oneSeries = {
                        name: `${item.tip}(份)`,
                        type: 'line',
                        yAxisIndex: 1,
                        symbol: 'circle',
                        symbolSize: this.charData.length > 30 ? 12 : 15,
                        smooth: 0.3,
                        lineStyle: {
                            width: 6,
                        },
                        itemStyle: {
                            borderWidth: 3,
                            borderColor: '#ffffff',
                        },
                        data: item.data,
                    };
                    seriesData.push(oneSeries);
                }
            })

            // Step 4: 组织 Chart option
            let option = {
                title: {
                    show: false,
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    // show: false,
                    top: 12,
                    data: legendData
                },
                grid: {
                    left: '3%',
                    right: '3%',
                    top: 50,
                    bottom: 10,
                    containLabel: true
                },
                toolbox: {
                    show: false,
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    // boundaryGap: false,
                    min: 0,
                    splitNumber: 4,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        padding: [8, 0, 0, 0],
                        color: "#909399"
                    },
                    data: xAxisData
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '金额(万元)',
                        alignTicks: true,
                        splitNumber: 4,
                        splitLine: {
                            lineStyle: {
                                type: 'dashed'
                            }
                        },
                        axisLabel: {
                            color: "#909399"
                        },
                    },
                    {
                        type: 'value',
                        name: '数量(份)',
                        alignTicks: true,
                        splitNumber: 4,
                        splitLine: {
                            lineStyle: {
                                type: 'dashed'
                            }
                        },
                        axisLabel: {
                            color: "#909399"
                        },
                    }
                ],
                series: seriesData,
                color: ['#409EFF', '#F56C6C', '#67C23A']
            };

            // Step 5: 生成 Chart 对象
            this.charEle.setOption(option);
            window.addEventListener("resize", () => {
                this.charEle.resize();
            });
        },
        checkEmptyDataFlag(data) {
            if (data && data.length > 0) {
                this.emptyFlag = false;
            } else {
                this.emptyFlag = true;
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.empty-data-wrap {
    padding-top: 20px;
    text-align: center;
    > img {
        width: 350px;
    }
}
.char-wrap {
    height: 400px;
}
</style>